import React, { useState } from "react";
import MyQRCodeComponent from "../shared-components/QrCode/MyQRCodeComponent";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faShareNodes } from "@fortawesome/free-solid-svg-icons";
import { formPages } from "../../constants";
import FormActionButton from "../shared-components/FormActionButton";
import { useBrand } from "../../hooks/useBrand";
import Text from "../shared-components/Text";
import { isValidMobile } from "../../utils/utils";
import MobileModal from "../shared-components/MobileModal";
import "./Success.css";
import "./AddressDetails.css";

export default function Success({ compensate, onNext }) {
  const [openModal, setOpenModal] = useState(false);
  const brand = useBrand();
  const [mobile, setMobile] = useState(compensate.mobile || "");
  const [mobileNumberError, setMobileNumberError] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const showVoucherSection = false;

  const vehicleMakes = [];
  const lenders = [];
  const vehicleRegs = [];

  compensate?.claims?.forEach((claim, index) => {
    if (claim.make) {
      vehicleMakes.push(`Claim ${index + 1} - ${claim.make}`);
    }
    if (claim.lender_name) {
      lenders.push(`Claim ${index + 1} - ${claim.lender_name}`);
    }
  });

  // vehicleRegistrationNumbers is an ARRAY OUTSIDE claims
  if (
    compensate?.vehicleRegistrationNumbers &&
    Array.isArray(compensate.vehicleRegistrationNumbers)
  ) {
    compensate.vehicleRegistrationNumbers.forEach((reg, index) => {
      vehicleRegs.push(
        `Claim ${vehicleMakes.length + lenders.length + index + 1} - ${reg}`,
      );
    });
  }
  // console.log(openModal);

  const handleShare = async () => {
    const currentUrl = window.location.href;
    const data = `${currentUrl}?r=${compensate.uid}`;
    if (navigator.share) {
      try {
        await navigator.share({
          title: "Car Finance Claims",
          text: "Here is the site I used to claim for my flight!",
          url: data,
        });
      } catch (error) {
        console.error("Error sharing:", error);
      }
    } else {
      navigator.clipboard
        .writeText(data)
        .then(() => {
          setOpenModal(true);
        })
        .catch((err) => {
          console.error("Error copying to clipboard:", err);
        });
    }
  };

  return (
    <>
      {showModal && (
        <MobileModal
          onClose={() => setShowModal(false)}
          onContinue={() => {
            setShowModal(false);
            onNext({ mobile: "" }, formPages.PostSuccess);
          }}
        />
      )}
      <div className="fdc-form" data-testid="page-success">
        <h2 className="title">
          {/* Thank you {compensate.firstName}, for the additional details! */}
          Great News! your details have been submitted!
        </h2>
        <div
          style={{
            background: "#f5e1d6",
            padding: "12px",
            borderRadius: "10px",
            margin: "10px 0",
            fontWeight: "600",
          }}
        >
          Claim reference: {compensate?.uniqueID}
        </div>
        <p className="mb-0">
          Our specialist team is reviewing your details to retrieve all of your
          vehicle finance claims.{" "}
          <b>
            Next steps will be shared with you soon, we'll keep you informed.
          </b>
        </p>
      </div>
      <div className="fdc-form gif-input">
        <div className="row">
          {/* Display submitted claims in same format as RequestFinanceLender */}
          {(compensate?.claims && compensate.claims.length > 0) ||
          (compensate?.vehicleRegistrationNumbers &&
            compensate.vehicleRegistrationNumbers.length > 0) ? (
            <div className="col-md-12">
              <div className="claims-card">
                <h3 className="claims-card-title">Your claims</h3>
                <div className="claim-divider" />

                <div className="claims-list-container">
                  {compensate.claims?.map((claim, index) => (
                    <div key={index}>
                      <div className="claim-item">
                        <div className="claim-name">
                          Claim {index + 1}: {claim.make || claim.lender_name}
                        </div>

                        <div className="claim-type">
                          {claim.make ? "Vehicle make" : "Finance lender"}
                        </div>
                      </div>

                      {(index < compensate.claims.length - 1 ||
                        (compensate?.vehicleRegistrationNumbers &&
                          compensate.vehicleRegistrationNumbers.length >
                            0)) && <div className="claim-divider" />}
                    </div>
                  ))}

                  {/* Display all vehicle registration numbers if present */}
                  {compensate?.vehicleRegistrationNumbers &&
                    compensate.vehicleRegistrationNumbers.length > 0 &&
                    compensate.vehicleRegistrationNumbers.map(
                      (regNumber, index) => (
                        <div key={`reg-${index}`}>
                          <div className="claim-item">
                            <div className="claim-name">
                              Claim{" "}
                              {(compensate.claims?.length || 0) + index + 1}:{" "}
                              {regNumber}
                            </div>

                            <div className="claim-type">
                              Vehicle registration
                            </div>
                          </div>

                          {index <
                            compensate.vehicleRegistrationNumbers.length -
                              1 && <div className="claim-divider" />}
                        </div>
                      ),
                    )}
                </div>
              </div>
            </div>
          ) : null}

          {/* <div className="col-md-12">
            <div className="form-block">
              <p>
                If you have any questions you can email us at{" "}
                <a href={`mailto:${brand.email}`}>{brand.email}</a>.
              </p>
              <p>
                We will send you a Welcome communication which will detail what
                happens next.
              </p>
              <p>Thank you for choosing {brand.displayName}!</p>
            </div>
          </div> */}
          {!compensate.mobile && (
            <>
              <div className="col-md-12">
                <div className="form-block">
                  <br />
                  <h2 style={{ fontWeight: 700, fontSize: "24px" }}>
                    Want important updates on your claim?
                  </h2>
                  <p>
                    Please enter your mobile number below so we can keep you
                    informed every step of the way.
                  </p>
                  <Text
                    className={"mb-0"}
                    placeholder={"Enter your mobile number (Optional)"}
                    onChange={(e) => {
                      let sanitizedValue = e.target.value.replace(/\D/g, "");

                      // Limit to 11 digits
                      sanitizedValue = sanitizedValue.slice(0, 11);

                      setMobile(sanitizedValue);

                      // Clear any existing errors while user is typing
                      setMobileNumberError(false);
                    }}
                    value={mobile}
                    id={"Mobile Number"}
                    testId="success-mobile"
                  />
                  {mobileNumberError ? (
                    <div className="error-message">
                      <p>
                        Please enter a valid mobile number, it must start with
                        07 and be 11 digits long.
                      </p>
                    </div>
                  ) : (
                    <></>
                  )}
                </div>
              </div>
            </>
          )}
          {showVoucherSection && (
            <>
              <div className="col-md-12">
                <div className="box-message fw-semibold theme-color-1 text-center">
                  <img
                    src="/icons/Amazon-£50-Voucher.png"
                    alt="voucher"
                    style={{ maxWidth: "100%" }}
                  />
                  <p className="ycm-orange">
                    Refer your friends and family and earn £50* in Amazon
                    vouchers for every new successful referral we receive.
                  </p>
                  <p>
                    Share the QR code with your friends and family via WhatsApp
                    or message:
                  </p>
                  <MyQRCodeComponent compensate={compensate} />
                </div>
              </div>

              <div className="col-md-12">
                <div className="py-2">
                  <button
                    onClick={handleShare}
                    style={{
                      padding: "15px",
                      backgroundColor: "var(--dark-bg)",
                      color: "#fff",
                      borderRadius: "5px",
                    }}
                    className="d-block mx-auto"
                  >
                    <div className="d-flex align-items-center">
                      <b className="pe-2">SHARE </b>
                      <FontAwesomeIcon icon={faShareNodes} size="2x" />
                    </div>
                  </button>
                </div>
              </div>
            </>
          )}

          <div className="col-md-12 text-center mt-4">
            <FormActionButton
              nextTitle="Next"
              nextTestId="success-btn-next"
              onNext={() => {
                // Validate mobile number if provided (optional field)
                if (mobile && mobile.length > 0 && !isValidMobile(mobile)) {
                  setMobileNumberError(true);
                  return;
                }

                // Show modal if mobile section is visible but no number entered
                if (!compensate.mobile && mobile === "") {
                  setShowModal(true);
                  return;
                }

                onNext(
                  {
                    mobile: isValidMobile(mobile) ? mobile : "",
                  },
                  formPages.PostSuccess,
                );
              }}
            />
          </div>
        </div>
      </div>
    </>
  );
}
